import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from '../../../environments/environment';

export class BaseService {
    httpOptions = { headers: new HttpHeaders(), params: new HttpParams() };

    constructor() {
        //console.log('BaseService.constructor');
    }

    setHttpOptions(): void {
        this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', 'application/json');
        const user = JSON.parse(sessionStorage.getItem('ownerInfo'));
        if (user) {
            this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + user.jwtToken);
        }
        this.httpOptions.params = new HttpParams();
    }

    setSAPHttpOptions(): void {
        this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', 'application/json');
        this.httpOptions.headers = this.httpOptions.headers.set('X-API-Key', environment.sapApiKey);
        const user = JSON.parse(sessionStorage.getItem('ownerInfo'));
        if (user) {
            this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + user.jwtToken);
        }
        this.httpOptions.params = new HttpParams();
    }

    setHttpParam(name: string, value: any): void {
        this.httpOptions.params = this.httpOptions.params.set(name, value);
    }

    setHttpParams(data: unknown): void {
        Object.keys(data).forEach((key) => {
            this.setHttpParam(key, data[key]);
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    handleError(error: HttpErrorResponse) {
        const message = error.error.message !== undefined ? error.error.message : error.message;
        //console.log('Error', message);
        return throwError(message);
    }
}
